var $f1f59338b6eca7eb$exports = {};
$f1f59338b6eca7eb$exports = {
    "endTime": `Hora de finalizaci\xf3n`,
    "startTime": `Hora de inicio`,
    "time": `Hora`
};


export {$f1f59338b6eca7eb$exports as default};
//# sourceMappingURL=es-ES.mjs.map
